import Notification from './src/main.js';

export default Notification;
